import React from 'react';
import { MapContainer, Marker, TileLayer, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import { Divider, IconButton, styled, Typography } from '@mui/material';

import { Icon, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

const StyledPopup = styled(Popup)({
	'.leaflet-popup-content-wrapper': {
		width: 'auto',
		borderRadius: 6
	},
	'.leaflet-popup-content': {
		margin: 12
	}
});

export default function CompaniesMap({ companies }: { companies: any[] }) {
	const getFullAddress = company =>
		`${company.comp_address || ''} ${company.comp_city || ''} ${company.dist_title || ''} ${
			company.ctry_title || ''
		}`;

	return (
		<DetailsSectionWrapper disablePadding>
			<MapContainer
				center={[42.30155, 12.34215]}
				zoom={4}
				className="z-0 h-full min-h-400 w-full"
				scrollWheelZoom={false}
			>
				<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
				<MarkerClusterGroup>
					{companies.map(
						(company, i) =>
							company.comp_lat &&
							company.comp_lng && (
								<Marker key={i} position={[company.comp_lat, company.comp_lng]}>
									<StyledPopup>
										<Typography variant="subtitle2">{company.comp_title}</Typography>
										<Typography variant="subtitle2" color="text.secondary">
											{company.comp_address}
										</Typography>
										<Typography variant="subtitle2" color="text.secondary">
											{company.comp_city} {company.dist_iso} {company.ctry_title}
										</Typography>
										<Divider className="mb-8 mt-8" />
										<IconButton
											size="small"
											onClick={() =>
												Utils.openLink({
													pathname: `/companies/details/${company.comp_uid}`,
													newTab: true
												})
											}
										>
											<Icon icon="open-in-new" />
										</IconButton>
										<IconButton
											size="small"
											onClick={() => Utils.openMaps(getFullAddress(company))}
										>
											<Icon icon="directions" />
										</IconButton>
									</StyledPopup>
								</Marker>
							)
					)}
				</MarkerClusterGroup>
			</MapContainer>
		</DetailsSectionWrapper>
	);
}
